import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { disableGA, trackPageView } from "./analytics";
import { useCookieConsent } from "../context/CookieConsentContext";

const GoogleAnalytics = () => {
  const location = useLocation();
  const { consent } = useCookieConsent();
  const analyticsAllowed = consent?.analytics === true;
  // Stop GA and clear cookies whenever consent is off
  useEffect(() => {
    if (!analyticsAllowed) {
      disableGA();
    }
  }, [analyticsAllowed]);
  useEffect(() => {
    if (!analyticsAllowed) return;

    // trackPageView already calls initGA() internally
    trackPageView(location.pathname + location.search);
  }, [analyticsAllowed, location.pathname, location.search]);

  return null;
};

export default GoogleAnalytics;
